// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* from https://codepen.io/MarkBoots/pen/BaJqKyY */

[slide-in-from] {
  opacity: 0;
  transform: translateY(var(--translateY,0)) translateX(var(--translateX, 0));
  animation: slideInFrom var(--sif-duration, 250ms) var(--sif-timing, ease-out) var(--sif-delay, 0ms) forwards;
}
[slide-in-from ^= "top"]    { --translateY: -100% }
[slide-in-from ^= "bottom"] { --translateY:  100% }
[slide-in-from \$= "left"]   { --translateX: -100% }
[slide-in-from \$= "right"]  { --translateX:  100% }

@keyframes slideInFrom{ to {  transform: unset; opacity: unset } }

.comes-with {
  display: flex;
  justify-content: center;
  padding: 0 5px;
}

.comes-with-gp .section-heading-ct h2 {
  color: var(--brand-white1);
  font-size: 2rem;
}

.comes-with-gp-wrapper {
  position: relative;
  background-color: #1D1E22;
  box-shadow: 0.25rem 0.25rem 0.25rem rgb(0 0 0 / .5);
  padding: 20px 10px;
  max-width: 400px;
  border: silver solid 8px;
  border-radius: 30px;
}
.comes-with-gp-wrapper::before {
  position: absolute;
  content: "";
  height: 20px;
  width: 20px;
  background-color: #6a6a6a;
  border: 1px solid silver;
  border-radius: 50%;
  top: 30px;
  left: 30px;

}

.comes-with-gp {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  padding-bottom: 30px;
}

.comes-with-item {
  padding: 0.5rem 1rem; 
  background-color: var(--clr); 
  color: black;
  border-radius: 0.25rem;
  font-size: 1.1rem;
  font-family: sans-serif; 
  font-weight: 700;
  box-shadow: 0.25rem 0.25rem 0.25rem rgb(0 0 0 / .5);
  width: 90%;
  text-align: center;
  border: 2px solid transparent;
}
.comes-with-item:hover {
  border: 2px dotted purple;
}

.comes-with-item a {
  color: purple;
}
.comes-with-item a:hover {
  color: blue;
}

.comes-with-item:nth-of-type(1){ --clr: #78C5D5; }
.comes-with-item:nth-of-type(2){ --clr: #459BA8; }
.comes-with-item:nth-of-type(3){ --clr: #79C268; }
.comes-with-item:nth-of-type(4){ --clr: #C5D747; }
.comes-with-item:nth-of-type(5){ --clr: #F5D63D; }
.comes-with-item:nth-of-type(6){ --clr: #F18C32; }
.comes-with-item:nth-of-type(7){ --clr: #f13d3d; }
.comes-with-item:nth-of-type(8){ --clr: #E868A1; }

.comes-with .fly-btn {
  color: white;
  display: flex;
  justify-content: center;
}

.comes-with .fly-btn button {
  background-color: var(--brand-blue1);
  padding: 10px 20px;
  border: 2px transparent solid;
  border-radius: 10px;
  font-size: 1.3rem;
  font-weight: bold;
  color: white;
  cursor: pointer;
  height: 3rem;
}

.comes-with .fly-btn button:hover {
  border: 2px var(--brand-green1) solid;
}`, "",{"version":3,"sources":["webpack://./src/pages/home/comes-with.css"],"names":[],"mappings":"AAAA,kDAAkD;;AAElD;EACE,UAAU;EACV,2EAA2E;EAC3E,4GAA4G;AAC9G;AACA,8BAA8B,oBAAoB;AAClD,8BAA8B,oBAAoB;AAClD,8BAA8B,oBAAoB;AAClD,8BAA8B,oBAAoB;;AAElD,wBAAwB,MAAM,gBAAgB,EAAE,eAAe,EAAE;;AAEjE;EACE,aAAa;EACb,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,mDAAmD;EACnD,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,yBAAyB;EACzB,wBAAwB;EACxB,kBAAkB;EAClB,SAAS;EACT,UAAU;;AAEZ;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,4BAA4B;EAC5B,YAAY;EACZ,sBAAsB;EACtB,iBAAiB;EACjB,uBAAuB;EACvB,gBAAgB;EAChB,mDAAmD;EACnD,UAAU;EACV,kBAAkB;EAClB,6BAA6B;AAC/B;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;AACA;EACE,WAAW;AACb;;AAEA,iCAAiC,cAAc,EAAE;AACjD,iCAAiC,cAAc,EAAE;AACjD,iCAAiC,cAAc,EAAE;AACjD,iCAAiC,cAAc,EAAE;AACjD,iCAAiC,cAAc,EAAE;AACjD,iCAAiC,cAAc,EAAE;AACjD,iCAAiC,cAAc,EAAE;AACjD,iCAAiC,cAAc,EAAE;;AAEjD;EACE,YAAY;EACZ,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;EAClB,6BAA6B;EAC7B,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,YAAY;EACZ,eAAe;EACf,YAAY;AACd;;AAEA;EACE,qCAAqC;AACvC","sourcesContent":["/* from https://codepen.io/MarkBoots/pen/BaJqKyY */\n\n[slide-in-from] {\n  opacity: 0;\n  transform: translateY(var(--translateY,0)) translateX(var(--translateX, 0));\n  animation: slideInFrom var(--sif-duration, 250ms) var(--sif-timing, ease-out) var(--sif-delay, 0ms) forwards;\n}\n[slide-in-from ^= \"top\"]    { --translateY: -100% }\n[slide-in-from ^= \"bottom\"] { --translateY:  100% }\n[slide-in-from $= \"left\"]   { --translateX: -100% }\n[slide-in-from $= \"right\"]  { --translateX:  100% }\n\n@keyframes slideInFrom{ to {  transform: unset; opacity: unset } }\n\n.comes-with {\n  display: flex;\n  justify-content: center;\n  padding: 0 5px;\n}\n\n.comes-with-gp .section-heading-ct h2 {\n  color: var(--brand-white1);\n  font-size: 2rem;\n}\n\n.comes-with-gp-wrapper {\n  position: relative;\n  background-color: #1D1E22;\n  box-shadow: 0.25rem 0.25rem 0.25rem rgb(0 0 0 / .5);\n  padding: 20px 10px;\n  max-width: 400px;\n  border: silver solid 8px;\n  border-radius: 30px;\n}\n.comes-with-gp-wrapper::before {\n  position: absolute;\n  content: \"\";\n  height: 20px;\n  width: 20px;\n  background-color: #6a6a6a;\n  border: 1px solid silver;\n  border-radius: 50%;\n  top: 30px;\n  left: 30px;\n\n}\n\n.comes-with-gp {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 10px;\n  padding-bottom: 30px;\n}\n\n.comes-with-item {\n  padding: 0.5rem 1rem; \n  background-color: var(--clr); \n  color: black;\n  border-radius: 0.25rem;\n  font-size: 1.1rem;\n  font-family: sans-serif; \n  font-weight: 700;\n  box-shadow: 0.25rem 0.25rem 0.25rem rgb(0 0 0 / .5);\n  width: 90%;\n  text-align: center;\n  border: 2px solid transparent;\n}\n.comes-with-item:hover {\n  border: 2px dotted purple;\n}\n\n.comes-with-item a {\n  color: purple;\n}\n.comes-with-item a:hover {\n  color: blue;\n}\n\n.comes-with-item:nth-of-type(1){ --clr: #78C5D5; }\n.comes-with-item:nth-of-type(2){ --clr: #459BA8; }\n.comes-with-item:nth-of-type(3){ --clr: #79C268; }\n.comes-with-item:nth-of-type(4){ --clr: #C5D747; }\n.comes-with-item:nth-of-type(5){ --clr: #F5D63D; }\n.comes-with-item:nth-of-type(6){ --clr: #F18C32; }\n.comes-with-item:nth-of-type(7){ --clr: #f13d3d; }\n.comes-with-item:nth-of-type(8){ --clr: #E868A1; }\n\n.comes-with .fly-btn {\n  color: white;\n  display: flex;\n  justify-content: center;\n}\n\n.comes-with .fly-btn button {\n  background-color: var(--brand-blue1);\n  padding: 10px 20px;\n  border: 2px transparent solid;\n  border-radius: 10px;\n  font-size: 1.3rem;\n  font-weight: bold;\n  color: white;\n  cursor: pointer;\n  height: 3rem;\n}\n\n.comes-with .fly-btn button:hover {\n  border: 2px var(--brand-green1) solid;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
